module.exports = __webpack_public_path__ + "img/logo_big_beta.845f2d75.svg";